import { HTMLAttributes, useEffect, useState } from 'react';
import {
  Card as CardType,
  CardInputEvent,
  SqEvent,
} from '@square/web-payments-sdk-types';
import SavedCardsContainer from 'typescript/apps/checkout_v3/components/payment/saved_cards/saved_cards_container';
import { paymentFormDivId } from 'typescript/utilities/web_payment_sdk';
import styles from 'typescript/apps/checkout_v3/components/payment/card.module.scss';
import { CHECKOUT_PAGE_CLICK_EVENTS } from 'typescript/constants/tracking';
import { onCheckoutPageClick } from 'typescript/utilities/tracking';
import { useCheckoutFlow } from 'typescript/context/checkout_flow';
import { CardEvents } from 'typescript/constants/enums/card';

interface CardProps extends HTMLAttributes<HTMLElement> {
  sqCard: CardType;
  canUseSavedCard: boolean;
}

// TODO: Add issuer installment support
const Card = ({ className, sqCard, canUseSavedCard }: CardProps) => {
  const { trackingData } = useCheckoutFlow();

  const [showCardForm, setShowCardForm] = useState(true);

  const eventTypeToClickEventMap = {
    [CardEvents.FOCUS_CLASS_ADDED]:
      CHECKOUT_PAGE_CLICK_EVENTS.card_form_focus_added,
    [CardEvents.FOCUS_CLASS_REMOVED]:
      CHECKOUT_PAGE_CLICK_EVENTS.card_form_focus_removed,
    [CardEvents.ERROR_CLASS_ADDED]:
      CHECKOUT_PAGE_CLICK_EVENTS.card_form_error_added,
    [CardEvents.ERROR_CLASS_REMOVED]:
      CHECKOUT_PAGE_CLICK_EVENTS.card_form_error_removed,
    [CardEvents.POSTAL_CODE_CHANGED]:
      CHECKOUT_PAGE_CLICK_EVENTS.card_form_postal_code_change,
  };

  useEffect(() => {
    if (!sqCard) return;

    const handleCardInputEvent = (cardInputEvent: SqEvent<CardInputEvent>) => {
      const clickEvent =
        eventTypeToClickEventMap[cardInputEvent.detail.eventType] || null;
      if (clickEvent) {
        onCheckoutPageClick({
          eventDesc: clickEvent,
          trackingData,
        });
      }
    };

    sqCard.addEventListener('focusClassAdded', handleCardInputEvent);
    sqCard.addEventListener('focusClassRemoved', handleCardInputEvent);
    sqCard.addEventListener('errorClassAdded', handleCardInputEvent);
    sqCard.addEventListener('errorClassRemoved', handleCardInputEvent);
    sqCard.addEventListener('postalCodeChanged', handleCardInputEvent);

    // eslint-disable-next-line consistent-return
    return () => {
      sqCard.removeEventListener('focusClassAdded', handleCardInputEvent);
      sqCard.removeEventListener('focusClassRemoved', handleCardInputEvent);
      sqCard.removeEventListener('errorClassAdded', handleCardInputEvent);
      sqCard.removeEventListener('errorClassRemoved', handleCardInputEvent);
      sqCard.removeEventListener('postalCodeChanged', handleCardInputEvent);
    };
  }, [sqCard]);

  return (
    <div
      data-testid="card-component"
      className={`${className} ${styles.relativePosition}`}
    >
      <div
        id={paymentFormDivId}
        style={{ display: showCardForm ? 'block' : 'none' }}
      />
      <SavedCardsContainer
        dropdownTopPosition={50}
        dropdownLeftPosition={0}
        setShowCardForm={setShowCardForm}
        sqCard={sqCard}
        canUseSavedCard={canUseSavedCard}
      />
    </div>
  );
};

export default Card;
